import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

export const ALLOWED_TAGS_FROM_MARKUP_CONFIG = {
  // Allow only the tags that we introduced from markup
  ALLOWED_TAGS: ['li', 'ul', 'strong', 'h1'],
};

const convertMarkupToBold = (markupText) => {
  // Regex: <two stars> (match everything minus new line) <two stars>
  const regex = /\*\*(.*?)\*\*/gm;
  return markupText.replace(regex, '<strong>$1</strong>');
};

const convertMarkupToList = (markupText) => {
  // Regex: <dash then whitespace> (match everything minus new line) <new line or end of the string>
  // /g is used to replace all occurrences
  const liRegex = /-\s(.*)(?:\n|$)/g;
  // Add <li> tag around every line that matched
  const liTags = markupText.replace(liRegex, '<li>$1</li>');

  // Regex: (greedily match everything minus new line that is
  // between the first <li> and the last </li>)
  // /g is used to replace all occurrences to handle multiple distinct lists
  const ulRegex = /(<li>.*<\/li>)/g;
  // Add the <ul> needed for the list
  const ulTags = liTags.replace(ulRegex, '<ul>$1</ul>');

  return ulTags;
};

const convertMarkupToHeader = (markupText) => {
  // Regex: <hash then whitespace> (match everything minus new line) <new line or end of the string>
  // /g is used to replace all occurrences
  const regex = /#\s(.*)(?:\n|$)/g;
  return markupText.replace(regex, '<h1>$1</h1>');
};

export const convertMarkupToHtmlSafely = (markupText) => {
  const textWithBoldHtmlString = convertMarkupToBold(markupText);
  const textWithBoldAndListHtmlString = convertMarkupToList(
    textWithBoldHtmlString
  );
  const textWithBoldAndListAndHeaderHtmlString = convertMarkupToHeader(
    textWithBoldAndListHtmlString
  );

  const sanitizedHtmlString = DOMPurify.sanitize(
    textWithBoldAndListAndHeaderHtmlString,
    ALLOWED_TAGS_FROM_MARKUP_CONFIG
  );
  const parsedSanitizedHtml = parse(sanitizedHtmlString);

  return parsedSanitizedHtml;
};
